/**
 * Invoice date formatting — single source of truth.
 *
 * The critical rule: a pure "YYYY-MM-DD" string (e.g. service_date) must be
 * parsed as LOCAL midnight. Passing it straight to `new Date("2026-05-29")`
 * parses UTC midnight, which toLocaleDateString then renders as the PREVIOUS
 * day for any timezone west of UTC — the off-by-one bug. Strings that carry a
 * time component (created_at, due_date) are parsed as a normal instant.
 *
 * Consolidates what used to be three identical copies (generateInvoicePdf
 * _fmtDate, Success _previewFmtDate, InvoiceDetail _detailFmtDate).
 */

export function parseInvoiceDate(iso) {
  if (!iso) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso));
  const d = m
    ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
    : new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

// month: "long" (PDF) or "short" (preview cards). locale optional.
export function formatInvoiceDate(iso, { month = "short", locale } = {}) {
  const d = parseInvoiceDate(iso);
  if (!d) return "";
  return d.toLocaleDateString(locale, { year: "numeric", month, day: "numeric" });
}
